export type AssetCoordinate = number | null | undefined
export type TripPoint = [number, number]

export const hasValidLocation = (lat: AssetCoordinate, lng: AssetCoordinate) =>
  typeof lat === 'number' &&
  Number.isFinite(lat) &&
  typeof lng === 'number' &&
  Number.isFinite(lng)

export const createTrips = (
  lat: AssetCoordinate,
  lng: AssetCoordinate
): TripPoint[] => {
  if (!hasValidLocation(lat, lng)) {
    return []
  }

  return [[lat, lng] as TripPoint]
}

export const appendTrip = (
  trips: TripPoint[],
  lat: AssetCoordinate,
  lng: AssetCoordinate
): TripPoint[] => {
  if (!hasValidLocation(lat, lng)) {
    return trips
  }

  return [...trips, [lat, lng] as TripPoint]
}
